import { forEach } from 'lodash';
import {
  SAVE_INPUT_VALUE,
  SAVE_GENERAL_SETTINGS
} from '../actions/constantsActions';

const initialState = {
  allowed_advance_days: {
    id: 1,
    name: 'allowed_advance_days',
    value: '5'
  },
  limit_to_day: {
    id: 4,
    name: 'limit_to_day',
    value: '6'
  },
  view_days_back: {
    id: 7,
    name: 'view_days_back',
    value: '5'
  },
  email_on: {
    id: 10,
    name: 'email_on',
    value: true
  },
  allowed_user_double_booking: {
    id: 16,
    name: 'allowed_user_double_booking',
    value: true
  },
  limit_mode_skip_weekends: {
    id: 19,
    name: 'limit_mode_skip_weekends',
    value: true
  },
  notifications_on: {
    id: 25,
    name: 'notifications_on',
    value: true
  }
};
const adminReducer = (state = initialState, action) => {
  const { type, payload, inputName, id } = action;
  const newState = {};
  switch (type) {
    case SAVE_GENERAL_SETTINGS:
      forEach(payload, (setting) => {
        newState[setting.name] = setting;
      });
      return {
        ...state,
        ...newState
      };
    case SAVE_INPUT_VALUE:
      return {
        ...state,
        [inputName]: {
          ...state[inputName],
          value: payload
        }
      };

    default:
      return state;
  }
};

export default adminReducer;
